/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GraphicalTakeOffPoint } from '@gh/builder-shared-data';
import { Point } from 'paper';

/**
 * Format input point values to decimal comma separated list
 */
@Directive({
  standalone: false,
  selector: '[ghPointValue]',
  providers: [
    DecimalPipe,
  ],
})
export class GraphicalTakeOffPointValueDirective implements OnInit, OnChanges {
  /**
   * Point
   *
   * @type {Point}
   */
  @Input() ghPointValue: GraphicalTakeOffPoint;

  /**
   * Point keys to display
   *
   * @type {string[]}
   */
  @Input() ghPointKeys: string[] = ['x', 'y'];

  /**
   * Transform format
   *
   * @type {string}
   */
  format: string = '1.0-0';

  /**
   * Element ref
   *
   * @type {HTMLInputElement}
   */
  el: HTMLInputElement;

  /**
   * Constructor
   *
   * @param {ElementRef} elementRef - Element ref
   * @param {DecimalPipe} decimalPipe - Decimal pipe
   * @returns {void}
   */
  constructor(
    private elementRef: ElementRef,
    private decimalPipe: DecimalPipe,
  ) {
    this.el = this.elementRef.nativeElement;
  }

  /**
   * Init
   *
   * @returns {void}
   */
  ngOnInit(): void {
    this.updateValue();
  }

  /**
   * On changes hook
   *
   * @param {SimpleChanges} changes - Changes
   * @returns {void}
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ghPointValue) {
      this.updateValue();
    }
  }

  /**
   * Update input value
   *
   * @returns {void}
   */
  updateValue(): void {
    if (!this.ghPointValue) {
      this.el.value = '';
      return;
    }

    const values: any[] = [];

    // Search needed point keys and transform
    // to decimal values
    this.ghPointKeys.forEach((key) => {
      values.push(
        this.decimalPipe.transform(this.ghPointValue[key], this.format),
      );
    });

    this.el.value = values.join(':');
  }
}
